//俄语
export default {
    Language: 'Русский',
    system: {
        homePage: {
            title1: 'Заголовок 1',
            title2: 'Заголовок 2',
            description1: 'Последние 7 дней',
            description2: 'Последние 6 месяцев',
        }
    },
    login: {
        register: 'Регистрация участника',
        usernamePls: 'Пожалуйста, введите имя пользователя',
        passwordPls: 'Пожалуйста, введите пароль',
        toRegister: 'Нет аккаунта? Зарегистрируйтесь сейчас',
        doLogin: 'Войти',
    },
    register: {
        repasswordPls: 'Пожалуйста, введите пароль для вывода',
        codePls: 'Пожалуйста, введите пригласительный код',
        register: 'Регистрация',
        xieyi: 'Согласен с условиями использования',
        xieyiPls: 'Пожалуйста, выберите соглашение об открытии счета ниже!',
    },
    mine: {
        xyfs: 'Кредитный рейтинг',
        ljjf: 'Накопленные очки',
        recharge: 'Пополнение',
        withdraw: 'Вывод',
        money: 'Доступный баланс',
        infomation: 'Основная информация',
        moneylog: 'История очков',
        withdrawrecord: 'Детали вывода',
        gamerecord: 'История подарков',
        notice: 'Объявления',
        mymove: 'История просмотров',
        loginpwd: 'Пароль входа',
        paypwd: 'Пароль использования',
        loginout: 'Выйти',
        paypwdhasseted: 'Пароль для вывода установлен. Если нужно изменить, обратитесь в службу поддержки',
        setbank: 'Пожалуйста, настройте карту для получения платежей!',
        lorr: 'Вход/Регистрация',
    },
    infomation: {
        username: 'ID участника',
        name: 'Имя',
        bankcard: 'Счет для вывода',
        phone: 'Номер телефона',
        recharge: 'Пополнение',
        amount: 'Имеющиеся очки',
        toserve: 'Пожалуйста, свяжитесь со службой поддержки',
        kfms: 'Для офлайн пополнения, пожалуйста, проконсультируйтесь с службой поддержки. Сумма пополнения через некоторые платежные каналы будет зачислена случайным образом до 1 десятичного знака, при оплате обязательно проверяйте',
    },
    withdraw: {
        title: 'Вывод',
        log: 'История вывода',
        method: 'Метод вывода',
        avmoney: 'Баланс для вывода',
        limit: 'Лимит вывода',
        submit: 'Запрос на вывод',
        xiane: 'Лимит за операцию',
        numbers: 'Количество выводов',
        time: 'Время зачисления',
        zuidi: 'Минимум',
        zuigao: 'Максимум',
        numsmax: 'Максимальный вывод наличных в день',
        ci: 'раз',
        timedetail: 'Обычное время перевода около 5 минут, самое быстрое в течение 2 минут',
        bank: 'Банковская карта',
        status1: 'На проверке',
        status2: 'Успешно',
        status3: 'Неудача',
        enterCorrectAmount: 'Пожалуйста, введите правильную сумму',
        selectBankCard: 'Пожалуйста, выберите банковскую карту для вывода',
        enterPayPassword: 'Пожалуйста, введите платежный пароль',
    },
    moneylog: {
        title: 'Детали средств',
        type1: 'Изменение',
        type2: 'Бонус',
        type3: 'Задание',
        type4: 'Награда',
        type5: 'Вывод',
        type6: 'Неудачный вывод',
        rechargeNote: '(Пополнение)',
    },
    setting: {
        loginpwdtitle: 'Изменить пароль входа',
        oldpwd: 'Пожалуйста, введите старый пароль',
        newpwd: 'Пожалуйста, введите новый пароль',
        renewpwd: 'Пожалуйста, введите новый пароль еще раз',
        change: 'Изменить',
        plseall: 'Пожалуйста, заполните форму полностью!',
        pswwrong: 'Введенные пароли не совпадают',
        paypwdtitle: 'Установить пароль средств',
        paypwd: 'Пожалуйста, введите пароль средств',
        repaypwd: 'Пожалуйста, введите пароль средств еще раз',
        title: 'Настройки',
        basicInfo: 'Настройки основной информации',
        loginPassword: 'Пароль входа',
        fundPassword: 'Пароль средств',
        logout: 'Выйти',
        payPasswordSet: 'Пароль для вывода установлен, для изменения обратитесь в службу поддержки',
        payPasswordNotSet: 'Не установлен',
        payPasswordHasSet: 'Установлен',
        confirm: 'Подтвердить',
    },
    home: {
        gonggao: 'Наслаждайтесь премиальным опытом',
        qgkf: 'Возможно по всей стране',
        hotlist: 'Популярный список рекомендаций',
        hotgame: 'Рекомендация заданий',
        gaoji: 'Продвинутый',
        smrz: 'Подтверждение на месте',
        videorz: 'Видеоподтверждение личности',
        star: 'Рейтинг',
        sg: 'Рост',
        xw: 'Грудь',
        diqu: 'Обслуживаемая территория',
        apply: 'Подать заявку на встречу',
        ssxz: 'Статус в реальном времени',
        joinvip: 'Присоединился к участникам',
    },
    video: {
        title: 'Видеотека',
        nums: 'Количество просмотров',
        bofangliang: 'Количество просмотров',
        hotlist: 'Популярные рекомендации',
        plsrefisrt: 'Пожалуйста, пополните счет для просмотра видео!',
        trialEnded: 'Пробный просмотр завершен',
        rechargeToWatch: 'Пожалуйста, пополните счет для бесплатного просмотра',
        goRecharge: 'Пополнить сейчас',
    },
    choose: {
        title: 'Лучшая ночь',
        nav: 'Выбор наложницы',
        apply: 'Заявка на совпадение',
        jianjie: 'Информация о красавице',
        move: 'Можно перемещать',
        click: 'Нажмите для подтверждения',
        detail: 'Подробная информация',
        videodetail: 'Видео в реальном времени',
    },
    common: {
        refresh: 'Успешно обновлено',
        noallow: 'Функция отключена!',
        disable: 'Отключить',
        all: 'Все',
        nomore: 'Больше нет',
        nodata: 'Нет данных',
        submit: 'Отправить',
        more: 'Смотреть больше',
        pinglunnav: 'Комментарии',
        pingluntitle: 'Комментарии',
        pldtitle: 'Детали комментария',
        minenav: 'Аккаунт',
        homenav: 'Главная',
        addbank: 'Добавить карту для получения',
        setbank: 'Счет для вывода',
    },
    game: {
        expect: 'Номер периода',
        jieguo: 'Данные',
        da: 'Большой',
        xiao: 'Маленький',
        dan: 'Нечетный',
        shuang: 'Четный',
        大: 'Большой',
        小: 'Маленький',
        单: 'Нечетный',
        双: 'Четный',
        order: 'Заказ задания',
        clear: 'Очистить заказ',
        submit: 'Подтвердить отправку',
        kjcc: 'Розыгрыш успешен, номер периода:',
        lxgly: 'Пожалуйста, свяжитесь с вашим менеджером',
        plsmoney: 'Пожалуйста, введите сумму!',
        plsnum: 'Пожалуйста, выберите номер!',
        moneynote: 'Недостаточно средств, пожалуйста, свяжитесь со службой поддержки для пополнения!',
        lefttime: 'Оставшееся время',
        lunci: 'Номер периода',
        workRecord: 'История заданий',
        day: 'День',
        period: 'Период',
        allWork: 'Все задания',
        reset: 'Сбросить',
        confirm: 'Подтвердить',
        bonusPoints: 'Бонусные очки',
        missionMoney: 'Детали суммы задания',
        missionResult: 'Результат задания',
        points: 'Очки',
        workPoints: 'Очки задания',
        giftCompleted: 'Подарок завершен',
        orderTime: 'Время заказа:',
        detail: 'Детали',
        content: 'Содержание',
        amount: 'Сумма',
        result: 'Результат',
        time: 'Время',
        win: 'Победа',
        missionFailed: 'Задание провалено',
    },
    kefu: {
        title: 'Онлайн поддержка',
        lianxi: 'Связаться',
        content: 'Обслуживание 24/7',
        defaultName: 'Онлайн поддержка',
    },
    setname: {
        title: 'Изменить настоящее имя',
        xingming: 'Имя',
        tips: 'Для безопасности вашего аккаунта, настоящее имя должно совпадать с именем на привязанной банковской карте',
        xmpls: 'Пожалуйста, введите настоящее имя',
        save: 'Сохранить',
        notreset: 'Не устанавливать повторно!',
        plsentername: 'Пожалуйста, введите имя!',
    },
    withdrawCenter: 'Центр вывода',
    withdrawRecord: 'История вывода',
    withdrawAmount: 'Сумма вывода',
    allMoney: 'Все',
    singleLimit: 'Лимит за операцию',
    lowest: 'Самый низкий',
    highest: 'Самый высокий',
    withdrawTimes: 'Количество выводов',
    maxDailyWithdraw: 'Максимальный вывод в день',
    times: 'раз',
    arrivalTime: 'Время зачисления',
    limitDescription: 'Описание лимитов',
    balance: 'Баланс',
    withdrawNow: 'Вывести сейчас',
    enterCorrectAmount: 'Пожалуйста, введите правильную сумму',
    personalReport: 'Персональный отчет',
    profitAmount: 'Сумма прибыли',
    profitFormula: 'Формула расчета прибыли: Сумма выигрыша - Сумма задания',
    taskAmount: 'Сумма задания',
    accountOffline: 'Аккаунт офлайн',
    loginRegister: 'Вход/Регистрация',
    loginForMore: 'Войдите, чтобы получить больше услуг!',
    author: 'Автор:',
    notification: 'Уведомление',
    changePhone: 'Изменить номер телефона',
    save: 'Сохранить',
    existingPhone: 'Текущий номер телефона',
    newPhone: 'Новый номер телефона',
    withdrawAccountRegister: 'Регистрация счета для вывода',
    selectBankCard: 'Пожалуйста, выберите банковскую карту',
    accountNumber: 'Номер счета',
    enterBankCardNumber: 'Пожалуйста, введите номер банковской карты',
    systemNotice: 'Системное уведомление',
    myMovie: 'Мои фильмы',
    completeTaskForMore: 'Выполняйте задания, чтобы получить больше билетов в кино',
    movieTicket: 'Билет в кино:',
    watchList: 'Список просмотра',
    noDataYet: 'Пока нет данных',
    setNameFirst: 'Пожалуйста, сначала установите имя перед привязкой счета для вывода!',
    setPasswordFirst: 'Пожалуйста, сначала установите пароль для вывода перед привязкой банковской карты!',
    accountHolder: 'Владелец счета',
    enterRealName: 'Пожалуйста, введите настоящее имя',
    withdrawPassword: 'Пароль для вывода',
    registerWithdrawPassword: 'Пожалуйста, зарегистрируйте пароль для вывода',
    bankCard: 'Банковская карта',
    orderContentLabel: 'Содержание заказа:',
    all: 'Все',
    bonusPointsLabel: 'Бонусные очки',
    waitingResultLabel: 'Ожидание результата',
    missionMoneyDetails: 'Детали суммы задания',
    points: 'Очки',
    switch: 'Переключатель',
    currentSelection: 'Текущий выбор:',
    quantity: 'Количество:',
    total: 'Всего',
    ticketAmount: 'Количество билетов',
    availablePoints: 'Доступные очки',
    verify: 'Проверить',
    possible: 'Возможно',
    thumb: 'Палец',
    privacyPolicy: 'Политика конфиденциальности',
    romanticDescription: 'Наша романтическая служба для защиты личной информации участников, регистрация возможна только через службу подтверждения личности или по рекомендации подтвержденного участника.',
    person1: 'Ся Юй',
    person2: 'Минь Сюэ',
	lishijl: 'История записей'
};